import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
    paper: {
        padding: 16,
        paddingBottom: 40
    },
    aiHighlight: {
        height: '80%',
        paddingLeft: '10px',
        borderLeft: '2px solid var(--background-purple)'
    },
    saveButtonContainer: {
        alignItems: 'center',
        justifyContent: 'flex-end',
        paddingBottom: 24,
        position: 'sticky',
        top: 0,
        height: 60,
        backgroundColor: 'white',
        width: '100%',
        display: 'flex',
        marginBottom: 0,
        zIndex: 9,
        [theme.breakpoints.down('xs')]: {
            justifyContent: 'center'
        }
    },
    saveButton: {
        display: 'flex',
        alignItems: 'center',
        gap: 12
    },
    largeAvatar: {
        width: theme.spacing(15),
        height: theme.spacing(15),
        cursor: 'pointer'
    },
    profileMainInfoContainer: {
        height: 144
    },
    profileMainBackground: {
        display: 'flex',
        alignItems: 'center',
        height: 100,
        backgroundColor: 'var(--beige)'
    },
    avatarContainer: {
        marginTop: 50,
        marginLeft: 15
    },
    profileNameContainer: {
        marginLeft: 15
    },
    nameMargin: {
        marginBottom: '-5px'
    },
    studentType: {
        color: 'var(--red)'
    },
    profileText: {
        textTransform: 'capitalize'
    },
    lastName: {
        fontSize: 16
    },
    firstName: {
        fontSize: 18
    },
    checkBox: {
        color: 'var(--dark-grey)'
    },
    gridFlex: {
        display: 'flex',
        justifyContent: 'flex-end',
        textAlign: 'end'
    },
    formControl: {
        width: '100%'
    },
    datePicker: {
        color: 'white',
        textColor: 'white',
        calendarTextColor: 'white',
        selectColor: 'white',
        selectTextColor: 'white',
        calendarYearBackgroundColor: 'white',
        headerColor: 'white'
    },
    button: {
        backgroundColor: 'var(--red)',
        color: 'white',
        '&:hover': {
            backgroundColor: 'var(--red)'
        }
    },
    progressBar: {
        color: 'var(--red)'
    },
    iconColor: {
        color: 'var(--red)'
    },
    buttonOutlined: {
        color: 'var(--red)',
        borderColor: 'var(--red)'
    },
    icon: {
        marginLeft: '8px',
        marginRight: '8px'
    },
    accordion: {
        border: 'solid var(--foreground-silver) 1px',
        boxShadow: 'none',
        margin: '4px 0',
        padding: '20px 20px',
        width: '100%',
        borderRadius: '20px !important',
        fontSize: '16px',
        '&::before': {
            height: 0
        }
    },
    accordionGrid: {
        marginBottom: '20px'
    },
    collapsed: {
        display: 'flex',
        flexDirection: 'row'
    },
    alertIconMain: {
        fontSize: '21px !important',
        color: theme.palette.fg.white,
        marginLeft: '8px',
        position: 'relative',
        top: '2px'
    },
    alertIcon: {
        float: 'right',
        fontSize: '22px !important',
        color: theme.palette.fg.purple,
        borderRadius: '100%',
        position: 'relative',
        bottom: '1px',
        left: '10px'
    },
    aiCheckAlert: {
        fontWeight: 'bold',
        marginRight: 'auto',
        color: theme.palette.fg.white,
        backgroundColor: theme.palette.bg.purple,
        borderRadius: '40px',
        padding: '4px 10px',
        width: 'auto',
        [theme.breakpoints.down('xs')]: {
            width: '60%',
            lineHeight: '1.1',
            padding: '4px 20px'
        }
    },
    sectionError: {
        border: `solid ${theme.palette.error.main} 1px`,
        margin: '4px 0',
        padding: '20px 20px',
        width: '100%',
        borderRadius: '20px !important',
        fontSize: '16px',
        '&::before': {
            height: 0
        }
    }
}))
